// extracted by mini-css-extract-plugin
module.exports = {"dragAndDrop":"drag_and_drop_dragAndDrop__2CsYV","dragging":"drag_and_drop_dragging__2YDl7"};